import styled from 'styled-components';
import en from '@assets/images/en.svg'
import ru from '@assets/images/ru.svg'
import { Link } from "gatsby";

export const CurrentLocale = styled.div`
    width: 24px;
    height: 24px;
    margin: 0 20px;
    
`;

export const En = styled(en)``;
export const Ru = styled(ru)``;

export const LocaleWrraper = styled.div`
    /* display: flex;
    justify-content: center;
    align-items: center; */
    position: relative;

`;

export const NewLocale = styled(Link)`
    padding: 15px 20px;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: left;
    align-items: center;

    svg {
        margin-right: 20px;
    }
`;

export const LocaleList = styled.div`
    width: 150px;
    position: absolute;
    padding-top: 58px;
    top: 0;
    right: 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease-in-out;

    ${LocaleWrraper}:hover & {
        opacity: 1;
        visibility: visible;
    }
`;

export const LocaleName = styled.span`
    ${NewLocale}:hover & {
            background: linear-gradient(225deg,#89dd65,#aedd65);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
    }
`;